import { ReactElement, useState } from "react";
import { Button, Col, Drawer, Form, Input, Row, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { DrawerFooter } from "../../components/GlobalStyles";
import { CREATE_COURT_REQUEST } from "../../redux/constants";
import { getAuthState } from "../../redux/selectors";

const { Option } = Select;
const { useForm } = Form;

type Props = {
  visible: boolean;
  onClose: () => void;
};

export function CreateCourtDrawer({ visible, onClose }: Props): ReactElement {
  const dispatch = useDispatch();
  const { currentUser } = useSelector(getAuthState);
  const { branchId } = useParams<{ branchId: string }>();
  const [form] = useForm();
  const { t } = useTranslation();

  const onFinish = (values: any) => {
    const formValue = {
      ...values,
      branchId,
      currentUser,
    };
    dispatch({ type: CREATE_COURT_REQUEST, payload: formValue });
    form.resetFields();
    onClose();
  };

  const onFinishFailed = (errorInfo: any) => {
    // eslint-disable-next-line no-console
    console.log("Failed:", errorInfo);
  };

  return (
    <Drawer
      title={t("court.create_court")}
      width={720}
      onClose={onClose}
      visible={visible}
      bodyStyle={{ paddingBottom: 80 }}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="name"
              label={t("court.name")}
              rules={[{ required: true, message: t("court.name_placeholder") }]}
            >
              <Input placeholder={t("court.name_placeholder")} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="place"
              label={t("court.court_place")}
              rules={[
                { required: true, message: t("court.court_place_placeholder") },
              ]}
            >
              <Select placeholder={t("court.court_place_placeholder")}>
                <Option value="indoor">{t("court.indoor")}</Option>
                <Option value="outdoor">{t("court.outdoor")}</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="description"
              label={t("court.description")}
              rules={[
                {
                  required: true,
                  message: t("court.description_placeholder"),
                },
              ]}
            >
              <Input.TextArea
                rows={4}
                placeholder={t("court.description_placeholder")}
              />
            </Form.Item>
          </Col>
        </Row>
        <DrawerFooter>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            {t("common.cancel")}
          </Button>
          <Button type="primary" htmlType="submit">
            {t("common.submit")}
          </Button>
        </DrawerFooter>
      </Form>
    </Drawer>
  );
}
